<div class="columns is-multiline fiscal-form" [formGroup]="fiscalForm" appAutoAudit [auditData]="fieldAuditData" [auditDisabled]="!!snapshotData">
  <div class="column is-12 form-container">
    <span class="label">Delegación AEAT</span>
    <p-dropdown 
      [options]="aeatCodesCombined"
      optionLabel="label"
      optionValue="value"
      [placeholder]="snapshotData ? '' : 'Seleccionar delegación AEAT'"
      formControlName="aeatSelector"
      [filter]="true"
      [emptyFilterMessage]="'No se encontraron resultados'">
    </p-dropdown>
  </div>

  <div class="column is-12 ob">
    <div class="form-container checkbox-with-tag ob-head">
      <div class="checkbox-label-container">
        <p-checkbox formControlName="intraCommunityOperatorObligation" binary="true" inputId="intraCommunityOperatorObligation"/>
        <label for="intraCommunityOperatorObligation">Operador intracomunitario</label>
        @if (isRoiActive) {
          <span class="tag active"><fa-icon [icon]="faCircle"></fa-icon>Activo</span>
        }
      </div>
    </div>

    @if (fiscalForm.get('intraCommunityOperatorObligation')?.value) {
      <div class="form-container ob-body">
        <div class="periods-grid periods-header">
          <span class="field-label">Fecha alta</span>
          <span class="field-label">Fecha baja</span>
          <span></span>
        </div>
        <div formArrayName="intraCommunityOperatorPeriods">
          @for (period of roiPeriods.controls; let i = $index; track i) {
            <div [formGroupName]="i" class="periods-grid periods-row">
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="startDate"/>
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="endDate"/>
              <a class="close-button" (click)="removeRoiPeriod(i)" title="Eliminar">
                <fa-icon [icon]="faTrash" [ngStyle]="{'cursor':'pointer'}"></fa-icon>
              </a>
            </div>
          }
          <button type="button" class="button add-button" (click)="addRoiPeriod()">Añadir periodo</button>
        </div>
      </div>
    }
  </div>

  <div class="column is-12 ob">
    <div class="form-container checkbox-with-tag ob-head">
      <div class="checkbox-label-container">
        <p-checkbox formControlName="codeEORI" binary="true" inputId="codeEORI"/>
        <label for="codeEORI">Código EORI</label>
        @if (isEoriActive) {
          <span class="tag active"><fa-icon [icon]="faCircle"></fa-icon>Activo</span>
        }
      </div>
    </div>

    @if (fiscalForm.get('codeEORI')?.value) {
      <div class="form-container ob-body">
        <div class="periods-grid periods-header">
          <span class="field-label">Fecha alta</span>
          <span class="field-label">Fecha baja</span>
          <span></span>
        </div>
        <div formArrayName="codeEORIPeriods">
          @for (period of eoriPeriods.controls; let i = $index; track i) {
            <div [formGroupName]="i" class="periods-grid periods-row">
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="startDate"/>
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="endDate"/>
              <a class="close-button" (click)="removeEoriPeriod(i)" title="Eliminar">
                <fa-icon [icon]="faTrash" [ngStyle]="{'cursor':'pointer'}"></fa-icon>
              </a>
            </div>
          }
          <button type="button" class="button add-button" (click)="addEoriPeriod()">Añadir periodo</button>
        </div>
      </div>
    }
  </div>

  <div class="column is-12 ob">
    <div class="form-container checkbox-with-tag ob-head">
      <div class="checkbox-label-container">
        <p-checkbox formControlName="presentationSIIObligation" binary="true" inputId="presentationSIIObligation"/>
        <label for="presentationSIIObligation">Obligación presentación SII</label>
        @if (isSiiActive) {
          <span class="tag active"><fa-icon [icon]="faCircle"></fa-icon>Activo</span>
        }
      </div>
    </div>

    @if (fiscalForm.get('presentationSIIObligation')?.value) {
      <div class="form-container ob-body">
        <div class="periods-grid periods-header">
          <span class="field-label">Fecha alta</span>
          <span class="field-label">Fecha baja</span>
          <span></span>
        </div>
        <div formArrayName="presentationSIIPeriods">
          @for (period of siiPeriods.controls; let i = $index; track i) {
            <div [formGroupName]="i" class="periods-grid periods-row">
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="startDate"/>
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="endDate"/>
              <a class="close-button" (click)="removeSiiPeriod(i)" title="Eliminar">
                <fa-icon [icon]="faTrash" [ngStyle]="{'cursor':'pointer'}"></fa-icon>
              </a>
            </div>
          }
          <button type="button" class="button add-button" (click)="addSiiPeriod()">Añadir periodo</button>
        </div>
      </div>
    }
  </div>

  <div class="column is-12 ob">
    <div class="form-container checkbox-with-tag ob-head">
      <div class="checkbox-label-container">
        <p-checkbox formControlName="isBigCompany" binary="true" inputId="isBigCompany"/>
        <label for="isBigCompany">Gran Empresa</label>
        @if (isBigCompanyActive) {
          <span class="tag active"><fa-icon [icon]="faCircle"></fa-icon>Activo</span>
        }
      </div>
    </div>

    @if (fiscalForm.get('isBigCompany')?.value) {
      <div class="form-container ob-body">
        <div class="periods-grid periods-header">
          <span class="field-label">Fecha alta</span>
          <span class="field-label">Fecha baja</span>
          <span></span>
        </div>
        <div formArrayName="isBigCompanyPeriods">
          @for (period of bigCompanyPeriods.controls; let i = $index; track i) {
            <div [formGroupName]="i" class="periods-grid periods-row">
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="startDate"/>
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="endDate"/>
              <a class="close-button" (click)="removeBigCompanyPeriod(i)" title="Eliminar">
                <fa-icon [icon]="faTrash" [ngStyle]="{'cursor':'pointer'}"></fa-icon>
              </a>
            </div>
          }
          <button type="button" class="button add-button" (click)="addBigCompanyPeriod()">Añadir periodo</button>
        </div>
      </div>
    }
  </div>

  <div class="column is-12 ob">
    <div class="form-container checkbox-with-tag ob-head">
      <div class="checkbox-label-container">
        <p-checkbox formControlName="paymentOnAccountIS403LIS" binary="true" inputId="paymentOnAccountIS403LIS"/>
        <label for="paymentOnAccountIS403LIS">Opción pago a cuenta IS 40.3 LIS</label>
        @if (isIS403LISActive) {
          <span class="tag active"><fa-icon [icon]="faCircle"></fa-icon>Activo</span>
        }
      </div>
    </div>

    @if (fiscalForm.get('paymentOnAccountIS403LIS')?.value) {
      <div class="form-container ob-body">
        <div class="periods-grid periods-header">
          <span class="field-label">Fecha alta</span>
          <span class="field-label">Fecha baja</span>
          <span></span>
        </div>
        <div formArrayName="paymentOnAccountIS403LISPeriods">
          @for (period of is403LISPeriods.controls; let i = $index; track i) {
            <div [formGroupName]="i" class="periods-grid periods-row">
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="startDate"/>
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="endDate"/>
              <a class="close-button" (click)="removeIS403LISPeriod(i)" title="Eliminar">
                <fa-icon [icon]="faTrash" [ngStyle]="{'cursor':'pointer'}"></fa-icon>
              </a>
            </div>
          }
          <button type="button" class="button add-button" (click)="addIS403LISPeriod()">Añadir periodo</button>
        </div>
      </div>
    }
  </div>

  <div class="column is-12 ob">
    <div class="form-container checkbox-with-tag ob-head">
      <div class="checkbox-label-container">
        <p-checkbox formControlName="isFiscalGroup" binary="true" inputId="isFiscalGroup"/>
        <label for="isFiscalGroup">Grupo Fiscal</label>
        @if (isFiscalGroupActive) {
          <span class="tag active"><fa-icon [icon]="faCircle"></fa-icon>Activo</span>
        }
      </div>
    </div>

    @if (fiscalForm.get('isFiscalGroup')?.value) {
      <div class="form-container ob-body">
        <div class="fiscal-group-grid fiscal-group-header">
          <span class="field-label">1er período imp. aplicable inicio</span>
          <span class="field-label">Fin</span>
          <span class="field-label">Nº Grupo Fiscal</span>
          <span class="field-label fiscal-group-check-label">Soc. dominante</span>
          <span class="field-label">Denominación soc. dominante</span>
          <span class="field-label">Sociedades</span>
          <span></span>
        </div>
        <div formArrayName="fiscalGroupPeriods" class="fiscal-group-periods-list">
          @for (period of fiscalGroupPeriods.controls; let i = $index; track i) {
            <div class="fiscal-group-period-item" [formGroupName]="i">
              <div class="fiscal-group-grid fiscal-group-period-row">
                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="startDate"/>
                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="endDate"/>
                <input class="search-input" type="text" pInputText formControlName="taxGroupNumber"/>
                <div class="fiscal-group-checkbox">
                  <p-checkbox formControlName="isDominantCompany" binary="true" [inputId]="'isDominantCompany_' + i"/>
                </div>
                @if (period.get('isDominantCompany')?.value === true) {
                  <input
                    class="search-input"
                    type="text"
                    pInputText
                    formControlName="dominantCompanyName"
                    [id]="'dominantCompanyName_' + i"
                    [attr.aria-label]="'Denominación soc. dominante'"
                  />
                  <div>
                    <label class="sr-only" [for]="'dominantCompanyClients_' + i">Sociedades</label>
                    <p-multiSelect
                      [options]="juridicClients"
                      [maxSelectedLabels]="2"
                      selectedItemsLabel="{0} sociedades"
                      optionLabel="name"
                      optionValue="id"
                      [placeholder]="snapshotData ? '' : 'Seleccionar'"
                      formControlName="dominantCompanyClientIds"
                      [filter]="true"
                      [inputId]="'dominantCompanyClients_' + i"
                      [emptyFilterMessage]="'No se encontraron resultados'"
                      class="fiscal-group-multiselect"
                    />
                  </div>
                } @else {
                  <div class="fiscal-group-span-2">
                    <label class="sr-only" [for]="'dominantCompanyClient_' + i">Soc. dominante</label>
                    <p-dropdown
                      [options]="juridicClients"
                      optionLabel="name"
                      optionValue="id"
                      [placeholder]="snapshotData ? '' : 'Seleccionar sociedad'"
                      formControlName="dominantCompanyClientId"
                      [filter]="true"
                      [showClear]="true"
                      [inputId]="'dominantCompanyClient_' + i"
                      [emptyFilterMessage]="'No se encontraron resultados'"
                      class="fiscal-group-dropdown"
                      (onChange)="onDominantCompanyClientSelect(i, $event.value)"
                    />
                  </div>
                }
                <a class="close-button" (click)="removeFiscalGroupPeriod(i)" title="Eliminar">
                  <fa-icon [icon]="faTrash" [ngStyle]="{'cursor':'pointer'}"></fa-icon>
                </a>
              </div>
              @if (period.get('isDominantCompany')?.value === true && getSelectedDominantClients(i).length > 0) {
                <div class="fiscal-group-grid fiscal-group-selected-row">
                  <div class="dominant-companies-list-box">
                    <ol class="dominant-companies-list" type="1">
                      @for (client of getSelectedDominantClients(i); track client.id) {
                        <li>{{ client.name }}</li>
                      }
                    </ol>
                  </div>
                </div>
              }
            </div>
          }
          <button type="button" class="button add-button" (click)="addFiscalGroupPeriod()">Añadir periodo</button>
        </div>
      </div>
    }
  </div>

  <div class="column is-12 ob">
    <div class="form-container checkbox-with-tag ob-head">
      <div class="checkbox-label-container">
        <p-checkbox formControlName="codeLEI" binary="true" inputId="codeLEI"/>
        <label for="codeLEI">Código LEI</label>
        @if (isLeiActive) {
          <span class="tag active"><fa-icon [icon]="faCircle"></fa-icon>Activo</span>
        }
      </div>
    </div>

    @if (fiscalForm.get('codeLEI')?.value) {
      <div class="form-container ob-body">
        <div class="periods-grid periods-header">
          <span class="field-label">Fecha alta</span>
          <span class="field-label">Fecha baja</span>
          <span></span>
        </div>
        <div formArrayName="codeLEIPeriods">
          @for (period of leiPeriods.controls; let i = $index; track i) {
            <div [formGroupName]="i" class="periods-grid periods-row">
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="startDate"/>
              <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="endDate"/>
              <a class="close-button" (click)="removeLeiPeriod(i)" title="Eliminar">
                <fa-icon [icon]="faTrash" [ngStyle]="{'cursor':'pointer'}"></fa-icon>
              </a>
            </div>
          }
          <button type="button" class="button add-button" (click)="addLeiPeriod()">Añadir periodo</button>
        </div>
      </div>
    }
  </div>

  @if (isPhysicalPerson) {
    <!-- Persona Física: Checkbox + Fecha de caducidad al lado -->
    <div class="column is-12 ob">
      <div class="ob-inline">
        <div class="form-container checkbox-with-tag ob-head">
          <div class="checkbox-label-container">
            <p-checkbox formControlName="digitalCertificate" binary="true" inputId="digitalCertificate"/>
            <label for="digitalCertificate">Certificado digital</label>
            @if (fiscalForm.get('digitalCertificate')?.value && digitalCertificates.length > 0 && isCertificateExpired(0)) {
              <fa-icon class="cert-alert" [icon]="faTriangleExclamation" title="Este certificado ha caducado"></fa-icon>
            }
          </div>
        </div>

        @if (fiscalForm.get('digitalCertificate')?.value && digitalCertificates.length > 0) {
          <div class="form-container" formArrayName="digitalCertificates">
            @for (certificate of digitalCertificates.controls; let i = $index; track i) {
              <div [formGroupName]="i" class="ob-inline-date">
                <span class="label">Fecha caducidad</span>
                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="expiryDate"/>
              </div>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    <!-- Persona Jurídica: Múltiples certificados con todos los campos -->
    <div class="column is-12 ob">
      <div class="form-container">
        <span class="label">Certificados digitales</span>
      </div>

      <div class="form-container ob-body">
        <div formArrayName="digitalCertificates">
          @for (certificate of digitalCertificates.controls; let i = $index; track i) {
            <div [formGroupName]="i" class="cert-row">
              <div>
                <span class="label">Representante</span>
                <p-dropdown
                  [options]="representativeOptions"
                  optionLabel="name"
                  optionValue="id"
                  [filter]="true"
                  filterBy="name"
                  [placeholder]="snapshotData ? '' : 'Buscar representante'"
                  appendTo="body"
                  formControlName="representativeId"
                  [emptyFilterMessage]="'No se encontraron resultados'"
                  (onChange)="onRepresentativeSelect(i, $event.value)"
                ></p-dropdown>
              </div>
              <div>
                <span class="label">NIF Representante</span>
                <input class="search-input" type="text" pInputText formControlName="representativeNif" readonly/>
              </div>
              <div>
                <div class="cert-expiry-label">
                  <span class="label">Fecha caducidad</span>
                  <fa-icon [icon]="faTriangleExclamation"
                           [style.color]="isCertificateExpired(i) ? '#ff6b6b' : 'transparent'"
                           [style.visibility]="isCertificateExpired(i) ? 'visible' : 'hidden'"
                           title="Este certificado ha caducado"></fa-icon>
                </div>
                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" [showClear]="true" formControlName="expiryDate"/>
              </div>
              <div class="cert-delete-col">
                <a class="close-button" (click)="removeCertificate(i)" title="Eliminar">
                  <fa-icon [icon]="faTrash" [ngStyle]="{'cursor':'pointer'}"></fa-icon>
                </a>
              </div>
            </div>
          }
        </div>
        <button type="button" class="button add-button" (click)="addCertificate()">Añadir certificado</button>
      </div>
    </div>
  }

  <div class="column is-12 form-container check-row">
    <p-checkbox formControlName="socialCollaboratorAuthorization" binary="true" inputId="socialCollaboratorAuthorization"/>
    <label for="socialCollaboratorAuthorization">Autorización colaborador social</label>
  </div>
  <div class="column is-12 form-container">
    <span class="label">Observaciones</span>
    <textarea class="search-input observations-field" pInputTextarea [autoResize]="true" formControlName="observations" rows="3" maxlength="2000"></textarea>
  </div>
</div>
@if (dateRangeError) {
  <div class="notification is-danger">
    <button class="delete" (click)="dateRangeError = ''"></button>
    <div class="notification-text">{{ dateRangeError }}</div>
  </div>
}

<div class="save-button-container">
  <button class="button save-button is-secondary" (click)="save()" [disabled]="isSavingFiscal">
    <fa-icon class="save-icon" [icon]="faFloppyDisk"></fa-icon> Guardar
  </button>
</div>

@if (isSaved) {
  <div class="notification is-success">
    <div class="notification-text">Guardado correctamente.</div>
    <div class="progress-bar-container">
      <progress class="progress is-small" min="0" max="100" #progressBar></progress>
    </div>
  </div>
}
